export default {"src":"/_next/static/media/process-step-marker.012583f7.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};